export default "__VITE_ASSET__BN4WBpN7__"